import { useState } from 'react';
import './App.css';
import TextForm from './components/TextForm';
import Alert from './components/Alert';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Header from './components/Header';

function App() {
  const [mode, setmode] = useState('light')
  
  const [alert, setAlert] = useState(null);
  const showalert = (message, type) => {
    setAlert({
      message: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 2000);
  }

  const [button, setbutton] = useState('primary');

  return (
    <>
      <Router>
        <Header/>
        <Alert alert={alert} />
        <div className="container my-5">
          <Routes>
            <Route exact path="/" element={<TextForm heading="Text-Utils : Convert Case" showalert={showalert} button={button} mode={mode}/>} />
          </Routes>
        </div>
      </Router>
    </>
  );
}


export default App;
